//#region Imports
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { DialogService } from '@app/core/services/dialog-service.service';
import { Injectable } from '@angular/core';

//#endregion Imports

@Injectable({
  providedIn: 'root'
})

export class ConfirmDialogService {

    //#region Constructor
    constructor(
        private dialogService: DialogService
    ){}
    //#endregion Constructor

    //#region Public Methods
    public OpenDialogConfirm(title:string, subtitle:string, message:string, onConfirm:() => void, OnCancel:() => void) : void {

        this.dialogService.OpenDialogConfirm(
            ConfirmDialogComponent,
            title,
            subtitle,
            message,
            onConfirm,
            OnCancel
        );
    }

    public OpenDialogConfirmDeleteChanges(onConfirm:() => void, OnCancel:() => void) : void {
        const Title: string = 'Confirm Change';
        const Subtitle: string = 'This will delete everything in this section.';
        const Message: string = 'Please confirm if you would like to proceed with this change.';

        this.dialogService.OpenDialogConfirm(
            ConfirmDialogComponent,
            Title,
            Subtitle,
            Message,
            onConfirm,
            OnCancel
        );
    }

    public OpenDialogDeleteConfirmation(onConfirm:() => void, OnCancel:() => void) : void {
        const Title: string = 'Delete Confirmation';
        const Subtitle: string = 'Are you sure you want to delete this item?';
        const Message: string = 'You will lose all the information saved for this item.';

        this.dialogService.OpenDialogConfirm(
            ConfirmDialogComponent,
            Title,
            Subtitle,
            Message,
            onConfirm,
            OnCancel
        );
    }
    //#endregion Public Methods

    //#region Private Methods
    //#endregion Private Methods
}
